
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.762 13.736h-7.12c-.4-2.42-2.219-4.251-4.399-4.251h-3.989c-2.18 0-4 1.832-4.4 4.251h-7.118c-1.9 0-3.45 1.543-3.45 3.435v.249c0 1.841 1.47 3.335 3.3 3.424l.75 26.9c.05 1.912 1.61 3.406 3.54 3.406h18.736c1.93 0 3.49-1.494 3.54-3.405l.75-26.9c1.83-.08 3.3-1.583 3.3-3.425v-.25c.01-1.89-1.54-3.434-3.44-3.434zm-15.508-2.25h3.99c1.08 0 2.02.966 2.35 2.26h-8.69c.33-1.294 1.27-2.26 2.35-2.26zm12.908 36.19c-.02.825-.7 1.473-1.54 1.473H20.885c-.84 0-1.52-.648-1.54-1.474l-.75-26.82h23.337l-.77 26.82zm4.05-30.256c0 .796-.65 1.443-1.45 1.443H16.736c-.8 0-1.45-.647-1.45-1.443v-.25c0-.796.65-1.443 1.45-1.443h27.026c.8 0 1.45.647 1.45 1.444v.249z"}}),_c('path',{attrs:{"d":"M37.213 28.072h.03c.54 0 .98-.428 1-.965l.05-1.962a1.007 1.007 0 00-.97-1.025h-.03c-.54 0-.98.428-1 .966l-.05 1.96a.989.989 0 00.97 1.026zM36.733 45.346h.03c.54 0 .98-.428 1-.966l.38-11.648a1 1 0 00-.97-1.026c-.5-.01-1.01.408-1.03.966l-.38 11.648a.994.994 0 00.97 1.026z"}})])
          )
        }
      }
    